import { useState } from 'react';

function validate<T extends object>(object : T, defaultFallbackValue: T) : T {
  return Object.assign(defaultFallbackValue,object);
}

export function useLocalStorage<T extends object>(key: string,  defaultFallbackValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? validate(JSON.parse(item),defaultFallbackValue) : defaultFallbackValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return  defaultFallbackValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  };

  return [storedValue, setValue] as const;
}